import { ChannelStatus } from '../../../hooks/useChannelStatus';
import { UnknownType, UserResponse } from 'stream-chat';

const getTooltipText = ({ channelStatus, guestName }) => {
    const tooltipText = {
        [ChannelStatus.Welcome]: `Introduce yourself by messaging before meeting online`,
        [ChannelStatus.HostSend]: `${guestName} must respond to your message before you can start a meeting.`,
        [ChannelStatus.GuestSend]: `You can start a meeting after you and ${guestName} exchange messages first.`,
    };
    return tooltipText[channelStatus];
};

interface useMeetingsStateProps {
    channelStatus: number;
    guestUser: UserResponse<UnknownType>;
}

const useMeetButtonTooltip = ({ channelStatus, guestUser }: useMeetingsStateProps) => {
    const tooltipText = getTooltipText({
        channelStatus,
        guestName: guestUser.firstName,
    });

    return { tooltipText };
};

export default useMeetButtonTooltip;
